import { Navigate } from "react-router-dom";

/**
 * Redirects to /Profile if user has cached auth session
 * This prevents LogIn page from rendering at all when user is authenticated
 */
export default function AuthRedirect({ children }) {
  // Synchronous check - no useEffect delay
  const hasAuth = localStorage.getItem('pws_auth') === '1';
  
  if (hasAuth) {
    return <Navigate to="/Profile" replace />;
  }
  
  return children;
}
